import { ConfigProvider } from "antd";
import jaJP from "antd/lib/locale/ja_JP";
import React from "react";
import { createRoot } from "react-dom/client";
import "moment/locale/ja";

import App from "./App";
import "i18n/i18n";
import reportWebVitals from "./reportWebVitals";

// GTMを本番環境にのみ挿入する関数
const injectGTM = () => {
  if (process.env.REACT_APP_ENV === "prod") {
    // <head>用のスクリプトタグ
    const script = document.createElement("script");
    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-MR7RSHNW');
    `;
    document.head.appendChild(script); // <head>の最後に追加

    // <body>用のnoscriptタグ
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MR7RSHNW"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.insertBefore(noscript, document.body.firstChild); // document.body.firstChild は<body>の最初の子要素
  }
};

// GTMを挿入
injectGTM();


ConfigProvider.config({
  theme: {
    primaryColor: "#00AEC4",
  },
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <ConfigProvider
    locale={jaJP}
    autoInsertSpaceInButton={false}
    getPopupContainer={(trigger) => {
      if (trigger?.className?.includes("ant-select-selector") || trigger?.className?.includes("ant-picker"))
        return trigger?.parentNode;
      return document?.body as any;
    }}
  >
    <App />
  </ConfigProvider>
);

reportWebVitals();
